import React, { useState, useEffect } from "react";
import { Cookie } from "@phosphor-icons/react";

const KEY = "factlify_cookies_v1";

export default function CookieBanner() {
  const [choice, setChoice] = useState(null);

  useEffect(() => {
    setChoice(localStorage.getItem(KEY));
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setChoice("accepted");
  };
  const reject = () => {
    localStorage.setItem(KEY, "rejected");
    setChoice("rejected");
    if (window.posthog && typeof window.posthog.opt_out_capturing === "function") {
      try { window.posthog.opt_out_capturing(); } catch (_) {}
    }
  };

  if (choice) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] bg-ink text-white border-t-2 border-safety"
         data-testid="cookie-banner">
      <div className="max-w-6xl mx-auto px-4 py-2.5 flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <Cookie size={16} weight="fill" className="text-safety shrink-0" />
          <p className="text-xs text-white/80 leading-snug">
            Cookies técnicas + analíticas anónimas.{" "}
            <a href="/legal/privacidad" className="underline hover:text-safety">Privacidad</a>.
          </p>
        </div>
        <div className="flex gap-2 shrink-0">
          <button onClick={reject} data-testid="cookies-reject"
            className="px-3 py-1 border border-white/30 text-white text-[10px] uppercase tracking-widest font-bold hover:border-white transition-colors">
            Rechazar
          </button>
          <button onClick={accept} data-testid="cookies-accept"
            className="px-3 py-1 bg-safety text-ink border border-safety text-[10px] uppercase tracking-widest font-bold hover:bg-white hover:border-white transition-colors">
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
}
